<div class="lv-label-tooltip-label">
  <div class="lv-label-tooltip-label">
    <div class="lv-label-tooltip-label-symbol"
         [ngClass]="{'lv-label-tooltip-label-symbol-mouse-pointer': showCursorAsPointer}"
         *ngIf="!!labelSymbol && !!labelSymbol.SymbolAlsPraefixJN">
      <mat-icon [ngClass]="[!!labelSymbol?.SymbolGroesseInPixel ? labelSymbol?.SymbolGroesseInPixel: '',
 !!labelSymbol.SymbolFarbe ? labelSymbol?.SymbolFarbe: '']" class="lv-symbol"
                [svgIcon]="labelSymbol?.Symbolbezeichnung"></mat-icon>
    </div>
    <div class="lv-label-tooltip-label" [ngClass]="{'lv-label-tooltip-label-mouse-pointer': showCursorAsPointer}">
      <span [innerHTML]="label | lvHyphenationPipe"></span>&nbsp;
      <sup *ngIf="isPflichtfeld">*&nbsp;&nbsp;</sup>
      <!-- notwendig, da es ansonsten die Höhe nicht zu Artefakten passt die ein Pflichtfeld sind -->
      <sup *ngIf="!isPflichtfeld">&nbsp;</sup>
    <ng-container *ngIf="tooltip">
      <ng-container *ngIf="!isCollapsable">
        <mat-icon *ngIf="mobile" [svgIcon]="'InfoCircle'" class="lv-info-icon"
                  (click)="onMobileClick()"></mat-icon>
        <mat-icon *ngIf="!mobile" [svgIcon]="'InfoCircle'" class="lv-info-icon"
                  matTooltipClass="lv-tooltip"
                  matTooltip="{{tooltip}}"
                  matTooltipPosition="above"></mat-icon>
      </ng-container>
      <mat-icon *ngIf="isCollapsable" [svgIcon]="'InfoCircle'"
                [ngClass]="{'lv-info-icon': true, 'open': showInfo}"
                (click)="toggleInfo()"></mat-icon>
    </ng-container>
    </div>
  </div>
  <div>
    <div class="lv-label-tooltip-label-symbol"
         [ngClass]="{'lv-label-tooltip-label-symbol-mouse-pointer lv-label-tooltip-label-symbol-after': showCursorAsPointer}"
         *ngIf="!!labelSymbol && !labelSymbol.SymbolAlsPraefixJN">
      <mat-icon [ngClass]="[!!labelSymbol?.SymbolGroesseInPixel ? labelSymbol?.SymbolGroesseInPixel: '',
 !!labelSymbol.SymbolFarbe ? labelSymbol?.SymbolFarbe: '']" class="lv-symbol"
                [svgIcon]="labelSymbol?.Symbolbezeichnung"></mat-icon>
    </div>
  </div>
</div>
